export function buildEntityMap(entities) {
    const newMap = new Map();
    entities.forEach((entity) => {
        if (!newMap.has(entity.id)) {
            newMap.set(entity.id, entity);
        }
    });
    return newMap;
}
//# sourceMappingURL=build-entity-map.js.map